import moment from "moment";
import { LoadState } from "../../constants/enums";
import { ILedger, ILedgerState, IMaterialOutward } from "./ledger.types";

export const defaultLedger: ILedger = {
  ledger_uuid: "",
  selling_name: "",
  quantity: "",
  invoice_no: "",
  billing_company_name: "",
  billing_company_uuid: "",
  balance: "",
  customer_name: "",
  type: "IN",
  status: "ACTIVE",
};

export const defaultMaterialOutward: IMaterialOutward = {
  material_outward_uuid: null,
  material_outward_date: null,
  project_uuid: null,
  project_name: null,
  product_uuid: null,
  product_name: null,
  quantity: 0,
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  status: "ACTIVE",
};

export const defaultLedgerState: ILedgerState = {
  ledger_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
};
